import React from 'react';
import { useDispatch } from 'react-redux';
import { hooks } from '@lifesize/clients.sdk';
import { colors } from '@lifesize/ux-assets';
import { makeStyles, Theme } from '@material-ui/core';
import { fade } from '@material-ui/core/styles';
import { openInCallModal } from 'actions/InCallModal';
import SearchComp from 'containers/GlobalSearch/GlobalSearchContainer';
import UpgradeButton from 'components/Header/UpgradeButton';
import UserBadge from 'components/Header/UserBadge';
import Modals from 'constants/Modals';
import UserMore from 'containers/Header/UserMoreMenuContainer';
import Help from 'containers/Header/Help';

const Header = () => {
  const dispatch = useDispatch();
  const isCallConnected = hooks.useCallConnected();
  const disabled = hooks.useIsRemoteModerationActive();
  const classes = useStyles({});

  const handleConfirmRemoteModerationEnd = (evt) => {
    evt.stopPropagation();
    dispatch(openInCallModal(Modals.endRemoteModeration));
  };

  return (
    <div className={classes.headerContainer} data-testid="appHeader">
      {!isCallConnected && (
        <>
          <div>
            <UserBadge />
            <UpgradeButton />
          </div>
          <SearchComp />
          <Help />
          <UserMore />
        </>
      )}
      {disabled && <div className={classes.cover} onClick={handleConfirmRemoteModerationEnd} />}
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) => ({
  headerContainer: {
    alignItems: 'center',
    background: colors.white,
    boxShadow: `0px 5px 15px ${fade(colors.black, 0.12)}`,
    display: 'flex',
    height: 60,
    padding: '0 18px 0 7.5px',
    position: 'relative',
    width: '100%',
    zIndex: 11,

    '& > *': {
      flex: '0 0 auto'
    },

    '& > *:first-child': {
      alignItems: 'center',
      display: 'flex',
      flex: '1 0 auto'
    }
  },
  cover: {
    backgroundColor: fade(colors.black, 0.4), // the overlay of the rest of the screen
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0
  }
}));

export default Header;
